import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { unsubscribeEmailRequest } from "../../services";
import { resolveApiFormErrors } from "../../utils";
import Loader from "../../components/Common/Loader";

import './verifyEmail.css';

export function UnsubscribeEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isUnsubscribed, setIsUnsubscribed] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // Extract token and user_id from the URL
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const user_id = params.get("user_id");

  useEffect(() => {
    if (!token || !user_id) {
      setErrorMessage("Invalid verification link.");
      setIsLoading(false);
      return;
    }

    // Make the API call to verify the email
    const unsubscribe = async () => {
      try {
        const res = await unsubscribeEmailRequest({ token, user_id });

        if (res?.success) {
          setIsUnsubscribed(true);
        } else {
          setIsUnsubscribed(false);
          const { displayError } = resolveApiFormErrors(res, {}, {
            fallbackMessage: "Failed to Unsubscribe Email.",
          });
          setErrorMessage(displayError);
        }
      } catch (error) {
        setIsUnsubscribed(false);
        setErrorMessage("Something went wrong. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    unsubscribe();
  }, [token, user_id]);

  return (
    <AuthLayout title="Verify Email">
      <div className="p-4 text-center">
        <div className="text-2xl mb-8">Unsubscribe Email</div>
        <div className="mb-4">
          {isLoading ? (
            <div className="authVerifyEmailLoaderContainer">
              <Loader className="loader" />
            </div>
          ) : isUnsubscribed === true ? (
            <div className="text-green-500">Your email has been unsubscribed successfully!</div>
          ) : isUnsubscribed === false ? (
            <div className="text-red-500">{errorMessage}</div>
          ) : (
            <div className="text-red-500">{errorMessage}</div>
          )}
          <Link to="/home">Home</Link>
        </div>
      </div>
    </AuthLayout>
  );
}
